document.addEventListener("DOMContentLoaded", function () {
    // Only run if carrer-list section exists on page
    if (!document.querySelector(".carrer-list")) return;

    // Filter functionality
    const filterTags = document.querySelectorAll(".filter-tag");
    const positionCards = document.querySelectorAll(".col-right__card.job-card");
    const jobOpeningCount = document.querySelector(".job-opening strong");

    let activeFilters = {
        location: [],
        "type-contracts": [],
        "work-mode": [],
    };

    function updatePositionVisibility() {
        let visibleCount = 0;

        positionCards.forEach((card, index) => {
            const cardLocation = card.getAttribute("data-location") || "";
            const cardTypeContracts = card.getAttribute("data-type-contracts") || "";
            const cardWorkMode = card.getAttribute("data-work-mode") || "";

            const matchLocation = activeFilters.location.length === 0 || activeFilters.location.includes(cardLocation);
            const matchTypeContracts = activeFilters["type-contracts"].length === 0 || activeFilters["type-contracts"].includes(cardTypeContracts);
            const matchWorkMode = activeFilters["work-mode"].length === 0 || activeFilters["work-mode"].includes(cardWorkMode);

            const shouldBeVisible = matchLocation && matchTypeContracts && matchWorkMode;
            const isWithinLimit = index < currentlyVisible;

            if (shouldBeVisible && isWithinLimit) {
                card.style.display = "flex";
                visibleCount++;
            } else {
                card.style.display = "none";
            }
        });

        // Update count
        if (jobOpeningCount) {
            jobOpeningCount.textContent = visibleCount;
        }
    }

    filterTags.forEach((tag) => {
        tag.addEventListener("click", function () {
            const filterType = this.getAttribute("data-filter");
            const filterValue = this.getAttribute("data-value");
            const isCurrentlyActive = this.classList.contains("active");

            if (isCurrentlyActive) {
                // If clicking on active tag, remove it from filter
                this.classList.remove("active");
                const index = activeFilters[filterType].indexOf(filterValue);
                if (index > -1) {
                    activeFilters[filterType].splice(index, 1);
                }
            } else {
                // If clicking on inactive tag, add it to filter
                this.classList.add("active");
                if (!activeFilters[filterType].includes(filterValue)) {
                    activeFilters[filterType].push(filterValue);
                }
            }

            // Update visibility
            updatePositionVisibility();
        });
    });

    // Show more functionality
    const showMoreBtn = document.querySelector(".show-more-btn");
    let currentlyVisible = 10;
    const increment = 10;

    function initializeCardVisibility() {
        // Hide cards beyond the initial limit
        positionCards.forEach((card, index) => {
            if (index >= currentlyVisible) {
                card.style.display = "none";
            }
        });

        // Show/hide the show more button
        if (showMoreBtn) {
            showMoreBtn.style.display = positionCards.length > currentlyVisible ? "flex" : "none";
        }

        // Update count after initialization
        updatePositionVisibility();
    }

    if (showMoreBtn) {
        showMoreBtn.addEventListener("click", function () {
            const hiddenCards = Array.from(positionCards).slice(currentlyVisible);
            const cardsToShow = hiddenCards.slice(0, increment);

            cardsToShow.forEach((card) => {
                card.style.display = "flex";
            });

            currentlyVisible += cardsToShow.length;

            // Hide button if all cards are visible
            if (currentlyVisible >= positionCards.length) {
                showMoreBtn.style.display = "none";
            }

            // Update visible count after showing more cards
            updatePositionVisibility();
        });
    }

    // Initialize - hide cards beyond limit and update visibility
    initializeCardVisibility();
});
